/*
import React, { useState , useRef, useEffect} from 'react';
import styles from './upcomingSessionPanel.module.css';
import Avatar from '@mui/material/Avatar';
import dayjs from 'dayjs';
import { useGlobalState } from '../../global_state_components/GlobalStateProvider.jsx';
import { useNavigate } from 'react-router-dom';


function UpcomingSessionPanel(){
  const {category, setCategoryFn} = useGlobalState();
  const navigate = useNavigate();

  const currentTime=dayjs();
  const formattedTime = currentTime.format('hh:mm A, ddd MMM D');

  const [beat, setBeat] = useState(false);

  function RedirectToVideoCallPage (){
    navigate('/jitsi');
  }

  const [is10MinutesBeforeSession, setIs10MinutesBeforeSession] = useState(true);


  useEffect(() => {
    const interval = setInterval(() => {
      setBeat(prevBeat => !prevBeat);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return(
    <div className={styles.upcoming_session_panel_div}>
      <h4 className={styles.upcoming}>Upcoming</h4>
      <div className={`${styles.upcoming_session_card} ${beat ? styles.beat_true : styles.beat_false}`}>
        <div className={styles.person_details_div}><Avatar className={styles.avatar_class} alt="Ekansh" src='/images/ekansh.jpg'/><p className={styles.person_name_class}>Ekansh Gupta</p></div>
        <p className={styles.details}>Physics</p>
        <p className={styles.details}>{formattedTime}</p>
        <p className={styles.details_red}>Starts in 1.30</p>
      </div>
      <div name="silent_study" onClick={RedirectToVideoCallPage} className={(is10MinutesBeforeSession===true)? styles.clicked_join : styles.join}>Join</div>
    </div>
  );
}

export default UpcomingSessionPanel;
*/



/*---------------------*/





import React, { useState, useEffect } from 'react';
import { useGlobalState } from '../../global_state_components/GlobalStateProvider.jsx';
import { useNavigate } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import dayjs from 'dayjs';
import styles from './upcomingSessionPanel.module.css';
import { axiosInstance } from '../../../lib/axiosInstance.js';
import HoverSmallProfile from '../../miscellaneous/HoverSmallProfile/HoverSmallProfile.jsx';

function UpcomingSessionPanel() {
  const { setIsAllSessionsClicked, category } = useGlobalState();
  const navigate = useNavigate();

  const [beat, setBeat] = useState(false);
  const [upcomingSession, setUpcomingSession] = useState(null);
  const [is10MinutesBeforeSession, setIs10MinutesBeforeSession] = useState(false);
  const [partnerName, setPartnerName] = useState('Your upcoming sessions appear here.');
  const [partnerId, setPartnerId] = useState('');
  const [myProfileId, setMyProfileId] = useState('');


  const [partnerTitleOrOccupation, setPartnerTitleOrOccupation] = useState('');
  const [partnerCollegeOrCompany, setPartnerCollegeOrCompany] = useState('');
  const [partnerMajorInCollegeOrSpecialisation, setPartnerMajorInCollegeOrSpecialisation] = useState('');

  const [showHoverCard, setShowHoverCard] = useState(false);

  useEffect(() => {
    const fetchMySessions = async () => {
      try {
        const response = await axiosInstance.get('/sessions/mine');
        const sessions = response.data;

        // Filter out the upcoming session
        const currentTime = dayjs();
        const upcoming = sessions
          .filter(session => dayjs(session.time).isAfter(currentTime))
          .sort((a, b) => dayjs(a.time).diff(dayjs(b.time)))[0];

        setUpcomingSession(upcoming);

        const profileResponse = await axiosInstance.get('/profile');
        setMyProfileId(profileResponse.data._id);

        if (upcoming) {

          if (profileResponse.data._id === upcoming.createdBy) {
            if (upcoming.isPaired){   //Or if (upcoming.pairedWith)
              const partnerResponse = await axiosInstance.get(`/profile/?userID=${upcoming.pairedWith}`);
              setPartnerId(upcoming.pairedWith);
              //---
              setPartnerName(partnerResponse.data.name);
              setPartnerTitleOrOccupation(partnerResponse.data.titleOrOccupation);
              setPartnerCollegeOrCompany(partnerResponse.data.collegeOrCompany);
              setPartnerMajorInCollegeOrSpecialisation(partnerResponse.data.majorInCollegeOrSpecialisation);
            }else{   //Or if (!upcoming.pairedWith)
              setPartnerName('Matching...');
            }
          } else {   //Or else if (profileResponse.data._id === upcoming.pairedWith)
            const partnerResponse = await axiosInstance.get(`/profile/?userID=${upcoming.createdBy}`);
            setPartnerId(upcoming.createdBy);
            //---
            setPartnerName(partnerResponse.data.name);
            setPartnerTitleOrOccupation(partnerResponse.data.titleOrOccupation);
            setPartnerCollegeOrCompany(partnerResponse.data.collegeOrCompany);
            setPartnerMajorInCollegeOrSpecialisation(partnerResponse.data.majorInCollegeOrSpecialisation);
          }
        }else{
          setPartnerName('No upcoming sessions');
        }
      } catch (error) {
        console.error('Error fetching my sessions:', error);
      }
    };

    fetchMySessions();

    //Here we are polling every 40 seconds. Not sure if this the best way because we are calling the sessions/mine API already in the DiscussAndLearnArea component and SilentStudyArea component.
    const interval = setInterval(fetchMySessions, 10000);

    return () => clearInterval(interval);

  }, []);


  //Check if the session is 10 minutes before.
  useEffect(() => {
    if (upcomingSession) {
      const sessionTime = dayjs(upcomingSession.time);
      const currentTime = dayjs();
      const diffInMinutes = sessionTime.diff(currentTime, 'minute');
      setIs10MinutesBeforeSession(diffInMinutes <= 10);
    }
  }, [upcomingSession]);


  //The heartbeat should start only 10 minutes before the session.
  useEffect(() => {
    let interval;

    if (is10MinutesBeforeSession && upcomingSession.isPaired) {
      interval = setInterval(() => {
        setBeat(prevBeat => !prevBeat);
      }, 1000);
    } else {
      setBeat(false);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [is10MinutesBeforeSession]);


  //Redirect to video call page.
  function RedirectToVideoCallPage() {
    // Pass the session id in route state so that VideoCall can use it as roomName
    //navigate('/jitsi', { state: {  userId: myProfileId, sessionId: upcomingSession._id } });     //In this context, the state property is an object used to pass additional data along with the navigation action. Rather than embedding this information in the URL, it’s sent in the navigation options.
    //navigate('/jitsi');  
    navigate('/jitsi', { state: {  userId: myProfileId.toString(), sessionId: upcomingSession._id.toString() } });    // myProfileId datatype is string and upcomingSession._id datatype is object. To convert upcomingSession._id to string, use upcomingSession._id.toString()
  }


  //If no upcoming session.
  if (!upcomingSession) {
    return (
      <div className={styles.upcoming_session_panel_div}>
        <div className={styles.upcoming_panel_header}>
          <h4 className={styles.upcoming}>Upcoming</h4>
          <h4 className={styles.upcoming}>All sessions</h4>
        </div>
        <div className={styles.upcoming_session_card}>
          <div className={styles.person_details_div}>
            <Avatar className={styles.avatar_class} alt={partnerName} src={'images/blank_profile_picture.webp'} />
            <p className={styles.person_name_class}>{partnerName}</p>
          </div>
        </div>
        <div name="upcoming_session_join_button" onClick={null} className={styles.join}>Join</div>
      </div>
    );
  }

  //If upcoming session there then. This should be placed below the above if statement.
  const formattedTime = dayjs(upcomingSession.time).format('hh:mm A, ddd MMM D');

  //If upcoming session there then.
  return (
    <div className={styles.upcoming_session_panel_div}>
      <div className={styles.upcoming_panel_header}>
        <h4 className={styles.upcoming}>Upcoming</h4>
        <h4 className={styles.all_sessions} onClick={() => {setIsAllSessionsClicked(prev => !prev)}}>All sessions</h4>
      </div>

      <div className={`${styles.upcoming_session_card} ${beat ? styles.beat_true : styles.beat_false}`}>
        <div className={styles.person_details_div} style={{ position: 'relative' }}>
          <Avatar className={styles.avatar_class} alt={partnerName} src={(upcomingSession.isPaired) ? `${process.env.REACT_APP_BASE_URL}/api/profile/image?userID=${partnerId}&type=profile` : 'images/blank_profile_picture.webp'} />
          <p
            className={styles.person_name_class}
            onMouseEnter={() => setShowHoverCard(true)}
            onMouseLeave={() => setShowHoverCard(false)}
          >
            {partnerName}
          </p>

          {showHoverCard && (
            <HoverSmallProfile
              name={partnerName}
              titleOrOccupation={partnerTitleOrOccupation}
              collegeOrCompany={partnerCollegeOrCompany}
              majorInCollegeOrSpecialisation={partnerMajorInCollegeOrSpecialisation}
              profilePicUrl={`${process.env.REACT_APP_BASE_URL}/api/profile/image?userID=${partnerId}&type=profile`}
            />
          )}
        </div>
        <p className={styles.details}>{upcomingSession.subject}</p>
        <p className={styles.details}>{upcomingSession.topic}</p>
        <p className={styles.details}>{upcomingSession.type === 'Discuss and learn with partner' ? 'Discuss and learn' : 'Silent study'}</p>
        <p className={styles.details}>{formattedTime}</p>
        {
          (is10MinutesBeforeSession && upcomingSession.isPaired) && <p className={styles.details_red}>Starts in {dayjs(upcomingSession.time).diff(dayjs(), 'minute')} minutes</p>
        }
      </div>
      <div name="upcoming_session_join_button"
        onClick={(is10MinutesBeforeSession && upcomingSession.isPaired) ? RedirectToVideoCallPage : null}
        className={(is10MinutesBeforeSession && upcomingSession.isPaired) ? styles.clicked_join : styles.join}
      >
        Join
      </div>
    </div>
  );
}

export default UpcomingSessionPanel;
